<template>
    <div v-show="showTable" class="width history_earnings__container tablereports mb-3">
        <template v-if="loading">
            <div id="ks-preloader">
                <div id="ks-loader"></div>
            </div>
        </template>
        <div class="flex flex-column sm:flex-row align-items-center justify-content-between gap-2 mb-3">
            <span class="history_earnings__title font-bold text-lg flex-order-1 align-self-start sm:align-self-auto">{{ $t('lang.partner.history_earnings.title') }}</span>
        </div>
        <div class="overflow-x-auto">
            <table class="history_earnings__table">
                <thead>
                    <tr>
                        <th class="text-center bg-primary">{{ $t('lang.partner.history_earnings.th_date') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.partner.history_earnings.th_summ') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.partner.history_earnings.th_frozen_summ') }}</th>
                        <th class="text-center bg-primary">{{ $t('lang.partner.history_earnings.th_client') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data">
                        <td class="text-center">{{ item.date }}</td>
                        <td class="text-center">{{ item.summ.formatMoney(0, ' ', ' ') }} &#8381;</td>
                        <td class="text-center">{{ item.frozen_summ.formatMoney(0, ' ', ' ') }} &#8381;</td>
                        <td class="text-center">{{ item.email }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-row">
                <KSPagination
                    ref="pagination"
                    :on-each-side="2"
                    @vuetable-pagination:change-page="loadingHistory"
                />
            </div>
        </div>
    </div>
</template>

<script>
import UserApi from "../../api/UserApi";
import KSPagination from "../../component/ks-table/KSPagination.vue";
import Alerts from "../../mixins/Alerts";

export default {
    name: "PartnerHistoryEarnings",
    mixins: [Alerts],
    data() {
        return {
            loading: false,
            page: 1,
            data: [],
        }
    },
    mounted() {
        this.loadingHistory();
    },
    computed: {
        showTable() {
            return this.data && this.data.length > 0;
        },
    },
    methods: {
        loadingHistory(page = 1) {
            let self = this;
            if (page === 'next') {
                page = this.page + 1
            }
            if (page === 'prev') {
                page = this.page - 1
            }
            if ((page > 1 && this.$refs.pagination.totalPage < page) || page < 1) {
                return;
            }
            this.page = page;
            this.loading = true;
            UserApi
                .getHistoryEarnings({page: page})
                .then(response => {
                    self.data = response.data;
                    self.$refs.pagination.setPaginationData({
                        current_page: response.current_page,
                        last_page: response.last_page
                    });
                })
                .catch(e => this.alertError((e)))
                .finally(() => this.loading = false);
        }
    },
    components: {
        KSPagination,
    }
}
</script>

<style scoped>
.history_earnings__title {
    color: #33404D;
}
.history_earnings__table {
    border-collapse: collapse;
    width: 100%;
}
.history_earnings__table tr:nth-child(even) {
    background: var(--keysso-table-even-row-background);
}
.history_earnings__table th {
    font-size: 13px;
    font-weight: 500;
    padding: 8px 6px;
}
.history_earnings__table td {
    padding: 8px 6px;
    font-size: 13px;
}
.pagination-row {
    padding: 0 10px;
    margin: 16px 0;
}
td i {
    font-size: 16px;
    padding: 0 5px;
    color: #5d80b3;
    cursor: pointer;
}
@media (max-width: 1500px) {
    .history_earnings__container {
        padding: 0 15px;
    }
}
</style>
